import React, { useState, useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import axios from 'axios';

// componentes
import OptionSelect from './OptionSelect';

// combo para consulta de versões
export default function ComboEmpresasArquivosTagsMultiplo({
    ids=[],
    alterou,
    className
}){

    // estados
    let [consulta, alterarConsulta] = useState([]);
    let [selecionados, alterarSelecionados] = useState([]);
    let [carregando, alterarCarregando] = useState(true);
    const [timeoutConsultar, alterarTimerConsultar] = useState(null);

    // consultar versões
    async function consultarRegistros(inputValue, callback = null){
        alterarCarregando(true);

        try{

            // faz a requisição
            let { data } = await axios.get(`/empresas/arquivos/tags`, { params: { 
                texto: inputValue,
                pagina: 1,
                registrosPorPagina: 20
            }});

            // filtra registros, desabilita quem já está na lista
            let registros = data.registros.map(registro => {
                // verifica se já está adicionado
                if(selecionados.find(selecionado => {
                    // console.log(selecionado.id, registro.id);
                    if(selecionado.id === registro.id){
                        return true;
                    }
                    return false;
                })){
                    registro.isDisabled = true;
                }
                return registro;
            });

            // altera os dados
            alterarConsulta([...registros]);
            if(callback !== null){
                callback(registros);
            }
            alterarCarregando(false);
        }catch({response}){}

    }

    // consultar os ids pré informados
    async function consultarIdsPreSelecionados(){
        alterarCarregando(true);

        try{

            // faz a requisição
            let { data } = await axios.get(`/empresas/arquivos/tags`, { params: { 
                tag: ids
            }});
            alterarSelecionados(data.registros);
            alterarCarregando(false);

        }catch({response}){}

        // consulta registros padrão de consulta
        consultarRegistros('');

    }

    // pre carrega algumas versões disponiveis
    useEffect(() => {
        if(ids.length > 0){
            consultarIdsPreSelecionados();
        }else{
            consultarRegistros('');
        }
    }, []);

    // ao alterar versões, retorna ids
    useEffect(() => {
        alterou(selecionados.map(g => g.tag));
    }, [selecionados]);

    // ao alterar a consulta
    const alterouConsulta = (inputValue, callback) => {

        // limpa o timeout
        clearTimeout(timeoutConsultar);

        // aguarda tempo sem rolar o slider
        alterarTimerConsultar(setTimeout(() => {
            consultarRegistros(inputValue, callback)
        }, 500));
        
    };

    return <AsyncSelect 
        isMulti
        isClearable
        className={className ?? ''}
        isLoading={carregando}
        loadOptions={alterouConsulta}
        defaultOptions={consulta}
        components={{
            Option: OptionSelect
        }}
        value={selecionados.map(selecionado => {
            return {label: <>{selecionado.descricao}</>, value: selecionado.tag}
        })}
        onChange={(evento, validar) => {

            // verifica ações
            if(validar.action === 'pop-value'){
                selecionados.pop();
                alterarSelecionados([...selecionados]);
            }else if(validar.action === 'remove-value'){
                alterarSelecionados(selecionados.filter((selecionado, a) => {
                    if(selecionado.tag === validar.removedValue.value){
                        return false;
                    }
                    return true
                }));
            }else if(validar.action === 'clear'){
                alterarSelecionados([]);
            }else if(validar.action === 'select-option'){
                let buscaFilho = selecionados.find(s => {
                    return s.tag === validar.option.tag;
                });

                // inclui se não já estiver incluido
                if(!buscaFilho){
                    alterarSelecionados([...selecionados, validar.option]);
                }
            }
        }}
        loadingMessage={() => 'Carregando...'}
        noOptionsMessage={() => 'Digite algo para fazer a consulta'}
        placeholder='Tags'
    />
    
}
